<!-- Normal view end -->
<!-- Mobile view start-->

<mat-toolbar class="mobileheader">
    <mat-toolbar-row style="width: 100%;" [style.margin-top]="mobileHeaderLogoGap" [style.height]="mobileHeaderHeight"
        fxLayout="row" fxLayoutAlign="space-between center" [style.margin-bottom]="mobileHeaderLogoGap"
        [style.margin-right]="mobileHeaderLogoGap">
        <section fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px" fxFlex="15">

            <span *ngIf="data.leftMenuHideInMobile==0">
                <button [style.color]="data.headerIconColour" *ngIf="url=='/';else elseBlock"
                    class="responsive-toggle" mat-icon-button (click)="toggleSidebar()">
                    <i style="font-size: 18px;" [style.color]="data.headerIconColour" class="material-icons ">menu</i>
                </button>
                <ng-template #elseBlock>
                    <button [style.color]="data.headerIconColour" class="responsive-toggle " mat-icon-button
                        (click)="back()">
                        <i class="material-icons ">keyboard_arrow_left</i>
                    </button>
                </ng-template>
            </span>
        </section>
        <section fxFlex="15"></section>
        <section fxFlex="40">
            <div *ngIf="layout==0&&mobileLogoEnable==0" fxLayoutAlign="center center">

                <calsoft-logo [sitename]="data.siteName" fxFlex [type]="'light'"></calsoft-logo>
            </div>

            <div *ngIf="layout==0&&mobileLogoEnable==1" fxFlex fxLayoutAlign="center center">

                <img [src]="serverPath3+mobileLogoSrc" onerror="this.src='';" style="height: 100px; width: 100%;"
                    [ngStyle]="{'height': '150px'}" />
            </div>

            <div *ngIf="layout==1&&mobileLogoEnable==0" fxLayout="row" fxLayoutAlign="center center">
                <calsoft-logo [sitename]="data.siteName" fxFlex fxLayoutAlign="center center"
                    [type]="'light'"></calsoft-logo>
            </div>

            <div *ngIf="layout==1&&mobileLogoEnable==1" fxFlex fxLayoutAlign="center center">
                <img [src]="serverPath3+mobileLogoSrc" fxLayoutAlign="center center" onerror="this.src='';"
                    style="height: 100px; width: 100%;" [ngStyle]="{'height': '150px'}" />
            </div>

        </section>
        <section  *ngIf="layout==0" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="2px" fxFlex="30">
            <div (click)="SignIn('login')" *ngIf="!userLoggedIn" 
                >
                <div *ngIf="disableLoginHeader==0" style="margin-right: -30px">
                    <button mat-button style="padding: 2px;" matSuffix (click)="hide = !hide"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" class="colorbtn">                        
                        <mat-icon>person</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="data.disableLoginHeader==0">
                <calsoft-HeaderUserProfileDropdown [data]="data" [style.color]="data.headerIconColour"
                    class="headerUser" *ngIf="userLoggedIn">
                </calsoft-HeaderUserProfileDropdown>
            </div>
            <div>
                <calsoft-cart-icon *ngIf="disableCartIconInHeader==0" [data]="data"
                    [style.color]="data.headerIconColour" [design]="'2'"></calsoft-cart-icon>
            </div>
        </section>

        <section  *ngIf="layout==1" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px" fxFlex="20">
            <calsoft-cart-icon *ngIf="disableCartIconInHeader==0" [data]="data"
                [style.color]="data.headerIconColour"></calsoft-cart-icon>
        </section>

    </mat-toolbar-row>

    <!-- <mat-toolbar-row *ngIf="url!='/cart'&&url!='/checkout/type'
    &&url!='/checkout' && data.disableSearchInHeader==0" style="padding: 0px 10px 10px 10px ; height: 43px;">
        <calsoft-search></calsoft-search>
    </mat-toolbar-row> -->
</mat-toolbar>

<mat-toolbar   [class.active]="showFixedHeader"  [style.height]="mobileHeaderHeight" style="padding:0px ; margin-left: 0px;" fxHide fxShow.lt-md class="calsoft-fixed-header mobileheader"
    fxLayout="row" fxLayoutAlign="space-between center">
    <mat-toolbar-row style="width: 100%;" [style.margin-top]="mobileHeaderLogoGap" [style.height]="mobileHeaderHeight"
        fxLayout="row" fxLayoutAlign="space-between center" [style.margin-bottom]="mobileHeaderLogoGap"
        [style.margin-right]="mobileHeaderLogoGap">
        <section fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px" fxFlex="15">

            <span *ngIf="data.leftMenuHideInMobile==0">
                <button [style.color]="data.headerIconColour" *ngIf="url=='/';else elseBlock"
                    class="responsive-toggle" mat-icon-button (click)="toggleSidebar()">
                    <i style="font-size: 18px;" [style.color]="data.headerIconColour" class="material-icons ">menu</i>
                </button>
                <ng-template #elseBlock>
                    <button [style.color]="data.headerIconColour" class="responsive-toggle " mat-icon-button
                        (click)="back()">
                        <i class="material-icons ">keyboard_arrow_left</i>
                    </button>
                </ng-template>
            </span>
        </section>
        <section fxFlex="15"></section>
        <section fxFlex="40">
            <div *ngIf="layout==0&&mobileLogoEnable==0" fxLayoutAlign="center center">

                <calsoft-logo [sitename]="data.siteName" fxFlex [type]="'light'"></calsoft-logo>
            </div>

            <div *ngIf="layout==0&&mobileLogoEnable==1" fxFlex fxLayoutAlign="center center">

                <img [src]="serverPath3+mobileLogoSrc" onerror="this.src='';" style="height: 100px; width: 100%;"
                    [ngStyle]="{'height': '150px'}" />
            </div>

            <div *ngIf="layout==1&&mobileLogoEnable==0" fxLayout="row" fxLayoutAlign="center center">
                <calsoft-logo [sitename]="data.siteName" fxFlex fxLayoutAlign="center center"
                    [type]="'light'"></calsoft-logo>
            </div>

            <div *ngIf="layout==1&&mobileLogoEnable==1" fxFlex fxLayoutAlign="center center">
                <img [src]="serverPath3+mobileLogoSrc" fxLayoutAlign="center center" onerror="this.src='';"
                    style="height: 100px; width: 100%;" [ngStyle]="{'height': '150px'}" />
            </div>

        </section>
        <section  *ngIf="layout==0" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="2px" fxFlex="30">
            <div (click)="SignIn('login')" *ngIf="!userLoggedIn" 
                >
                <div *ngIf="disableLoginHeader==0" style="margin-right: -30px">
                    <button mat-button style="padding: 2px;" matSuffix (click)="hide = !hide"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" class="colorbtn">                        
                        <mat-icon>person</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="data.disableLoginHeader==0">
                <calsoft-HeaderUserProfileDropdown [data]="data" [style.color]="data.headerIconColour"
                    class="headerUser" *ngIf="userLoggedIn">
                </calsoft-HeaderUserProfileDropdown>
            </div>
            <div>
                <calsoft-cart-icon *ngIf="disableCartIconInHeader==0" [data]="data"
                    [style.color]="data.headerIconColour" [design]="'2'"></calsoft-cart-icon>
            </div>
        </section>

        <section  *ngIf="layout==1" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px" fxFlex="20">
            <calsoft-cart-icon *ngIf="disableCartIconInHeader==0" [data]="data"
                [style.color]="data.headerIconColour"></calsoft-cart-icon>
        </section>

    </mat-toolbar-row>
</mat-toolbar>
<!-- Mobile View  end -->